export default "__VITE_ASSET__BjUMdy7B__"